import { render, staticRenderFns } from "./manage_organization_button.vue?vue&type=template&id=2afdfef8"
import script from "./manage_organization_button.vue?vue&type=script&lang=js"
export * from "./manage_organization_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports